"use client";
import React, { useState, useEffect } from "react";
import { Container, Drawer } from "@mui/material";
import { getHeader, getHeaderNavMain } from "./request/requestList";
import "./headernav.scss";
import _ from "lodash";
import { switchLanguage, openTarget, openNewWindow } from "@/app/utils/Common";
import {
  LANGTYPE_EN,
  LANGUAGE,
  str2LangCode,
  useLanguage,
} from "@/app/utils/LanguageContext";
import SearchIcon from "@mui/icons-material/Search";
import { redirectPage } from "@/app/utils/Common";
import "./comm.scss";
import { textSize } from "./utils/MixinSize";
import SubMenu from "./subMenu";

type propType = {
  data?: any;
};

const HeaderNav = (props: propType) => {
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [headerData, setHeader] = useState<any>();
  const [open, setMainMenuOpen] = useState<boolean>(false);
  const [mainMenu, setMainMenu] = useState<any[]>([]);
  // const [raceSiteMenu, setRaceSiteMenu] = useState<any[]>([]);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [showDisplayName, setShowDisplayName] = useState("");

  const toggleMainMenu = (open: boolean) => () => {
    setMainMenuOpen(open);
  };
  const [simulcastMainMenu, setSimulcastMainMenu] = useState<any>(null);
  const clientQuery = props.data?.simulcastMainMenu;
  useEffect(() => {
    setSimulcastMainMenu(clientQuery);
  }, []);

  const changeMenu = (e: any, hiddenId: string, displayId: string) => {
    const hideElement = document.getElementById(hiddenId);
    if (!!hideElement) hideElement.className = "inactive";
    const displayElement = document.getElementById(displayId);
    if (!!displayElement) displayElement.className = "active";
  };

  useEffect(() => {
    getHeaderNavMain({ language: lang.langCode })
      .then((res: any) => {
        normalizeMainMenu(res);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    getLoginStatus();
  }, []);
  let count = 0;
  const getLoginStatus = () => {
    const isUserProfileLoaded = localStorage.getItem("IsUserProfileLoaded");
    console.log(
      "getLoginInfo getLoginStatus isUserProfileLoaded",
      isUserProfileLoaded
    );
    if (
      count <= 10 &&
      (isUserProfileLoaded == "false" || !isUserProfileLoaded)
    ) {
      setTimeout(() => {
        count++;
        console.log("getLoginInfo Mobile getLoginStatus no");
        return getLoginStatus();
      }, 1000);
    } else if (
      isUserProfileLoaded ||
      count > 10
      // || WCIPCookie.isLoggedIn()
    ) {
      console.log("getLoginInfo Mobile getLoginStatus end");
      // refreshGlobalLoginControl();
    }
  };

  // const refreshGlobalLoginControl = () => {
  //   const custProIn = cookie.load("custProIn");
  //   const {isLogin, displayName} = getLoginInfo(custProIn, lang.langType);
  //   setIsLogin(isLogin);
  //   setShowDisplayName(displayName);
  //   console.log("getLoginInfo", isLogin, displayName, window.WCIPCookie?.isLoggedIn())
  // };

  useEffect(() => {
    getHeader({ language: lang.langCode })
      .then((res: any) => {
        const data = res?.item;
        if (data !== null && data !== undefined) {
          setHeader(data);
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);

  const normalizeMainMenu = (res: any) => {
    console.log('[-----normalizeMainMenu]', res)
    const data = res?.item?.data;
    if (data !== null && data !== undefined) {
      _.forEach(data, function(item1) {
        item1.seqIndex = Number(item1?.seq?.value || "999") ;
        if(item1.children !== null && item1.children !== undefined){
            item1.children?.sort((a:any, b:any) => {
              return a?.seq?.value - b?.seq?.value
            })
          _.forEach(item1.children, function(item2) {
            item2.seqIndex = Number(item2?.seq?.value || "999") ;
            if(item2.children !== null && item2.children !== undefined){
              item2.children?.sort((a:any, b:any) => {
                return a?.seq?.value - b?.seq?.value
              })
              _.forEach(item2.children, function(item3) {
                item3.seqIndex = Number(item3?.seq?.value || "999") ;
                if(item3.children !== null && item3.children !== undefined){
                  item3.children?.sort((a:any, b:any) => {
                    return a?.seq?.value - b?.seq?.value
                  })
                  _.forEach(item3.children, function(item4) {
                    item4.seqIndex = Number(item4?.seq?.value || "999") ;
                  });
                }
              });
            }
          });
        }
      });
      const sortedData = _.sortBy(data, ['seqIndex']); 
      setMainMenu(sortedData);
    }
  }

  const subMena = _.sortBy(
    mainMenu.filter((item) => item.name === "02-Racing" && item.label.value)[0]
      ?.children || [],
    ["seqIndex"]
  );
  return (
    <>
      <Container
        disableGutters
        maxWidth={false}
        sx={{ display: { xs: "none", lg: "block" }, width: "952px" }}
      >
        <div className="nav-block" id="mainNav">
          <div className="nav-block">
            <div className="container">
              <div className="navbar">
                <div
                  className="collapse navbar-collapse"
                  id="bs-example-navbar-collapse-1"
                >
                  <nav className="main-nav nav-en">
                    <ul
                      className={`nav nav-level-1 ${
                        lang.langType === LANGTYPE_EN ? "" : "nav-level-1-ch"
                      } commBContent`}
                      // style={{ padding: isMobile ? "" : "0 16px" }}
                    >
                      {mainMenu.map((item, index) => {
                        if (item.label?.value) {
                          return (
                            <li
                              key={"nav" + index}
                              id={item.name}
                              style={{
                                borderLeft:
                                  index === 0 ? "1px solid #003c84" : "",
                                borderRight:
                                  index === mainMenu.length - 1
                                    ? "1px solid #003c84"
                                    : "",
                              }}
                            >
                              {item.name === "02-Racing" ? (
                                <a
                                  className="active"
                                  target={openNewWindow(item?.target?.value)}
                                  href={item.link?.value || "javascript:;"}
                                >
                                  {item.label?.value}
                                </a>
                              ) : (
                                <a
                                  target={openNewWindow(item?.target?.value)}
                                  href={item.link?.value || "javascript:;"}
                                >
                                  {item.label?.value}
                                </a>
                              )}
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </nav>
                  <nav className="second-nav" id="second-nav-container">
                    <ul
                      className={`dropdown ${
                        lang.langType === LANGTYPE_EN ? "" : "dropdown_ch"
                      } navbar-hkjc index commBContent`}
                      id="nav-racing"
                      // style={{ padding: isMobile ? "" : "10px 16px" }}
                    >
                      {subMena.map((sub: any, idx: any) => {
                        if (sub?.label?.value) {
                          return (
                            <li
                              key={`subMena_${idx}`}
                              onMouseLeave={hideSubMenu}
                            >
                              <a
                                id={sub.name}
                                href={sub.link.value || "javascript:;"}
                                target={openNewWindow(sub?.target?.value)}
                                onMouseEnter={displaySubMenu}
                              >
                                {sub?.label?.value}
                              </a>
                              <ul>
                                {!!sub.children ? (
                                  _.sortBy(sub.children, ["seqIndex"]).map(
                                    (lvl: any, i: number) => {
                                      if (lvl.label.value) {
                                        return (
                                          <li key={`sub_${i}`}>
                                            <a
                                              id={lvl.name}
                                              href={lvl.link.value}
                                              target={openNewWindow(
                                                lvl?.target?.value
                                              )}
                                              className={
                                                lvl.children?.filter((i:any) => i?.label?.value && i?.link?.value).length > 0
                                                  ? "nav-arrow"
                                                  : ""
                                              }
                                              onMouseEnter={displaySubMenu2}
                                            >
                                              {lvl.label.value}
                                            </a>
                                            <ul>
                                              {!!lvl.children ? (
                                                _.sortBy(lvl.children, [
                                                  "seqIndex",
                                                ]).map(
                                                  (last: any, j: number) => {
                                                    if (last.label.value) {
                                                      return (
                                                        <li key={`last_${j}`}>
                                                          <a
                                                            id={last.name}
                                                            href={
                                                              last.link.value
                                                            }
                                                            target={openNewWindow(
                                                              last?.target
                                                                ?.value
                                                            )}
                                                          >
                                                            {last.label.value}
                                                          </a>
                                                        </li>
                                                      );
                                                    }
                                                  }
                                                )
                                              ) : (
                                                <></>
                                              )}
                                            </ul>
                                          </li>
                                        );
                                      }
                                    }
                                  )
                                ) : (
                                  <></>
                                )}
                              </ul>
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </nav>
                </div>
                <div className="clear"></div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Container sx={{ display: { lg: "none" } }}>
        <div
          style={{ position: "absolute", top: "8px", right: "8px" }}
          onClick={toggleMainMenu(true)}
        >
          <a id="btn-menu-mobile" />
        </div>
        <Drawer open={open} onClose={toggleMainMenu(false)} anchor={"right"}>
          <nav id="mainNav-mobile">
            <div className="mobileTitle" style={{ display: "flex" }}>
              {/* <div id="ewinContainer" className="mobile-top-ewin">
                <a className="ewin" onClick={(e) => waTracker('header_ewin_home')} href="//bet.hkjc.com/default.aspx?lang=en" target="_blank">
                  <img src={getStaticSrcPath("/commonImg/spacer.png")} style={{ border: 0, width: 39, height: 40 }} alt="eWin" />
                </a>
              </div> */}
              <span className="mobile-top-login" style={{ display: "flex" }}>
                <span>
                  <a
                    className="ewin"
                    onClick={(e) => waTracker("header_ewin_home")}
                    href={headerData?.RightLink?.value}
                    target={openTarget(headerData?.RightLinkNewWindow?.value)}
                  >
                    <img
                      src={
                        headerData?.RightImage?.src
                          ? headerData?.RightImage?.src
                          : `/commonImg/icon_ewin.png`
                      }
                      style={{ border: 0, width: 39, height: 40 }}
                      alt={headerData?.RightImage?.alt}
                      id="imgSubLogo"
                    />
                  </a>
                </span>
                <span
                  className="beforelogin"
                  style={{ display: isLogin ? "none" : "" }}
                >
                  <a
                    className="login"
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "login", lang.langType)}
                  >
                    {t("login")}
                  </a>{" "}
                  /
                  <a
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "register", lang.langType)}
                  >
                    {t("register")}
                  </a>{" "}
                  /
                  <a
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "help", lang.langType)}
                    className="faq"
                  >
                    {t("faq")}
                  </a>
                  &nbsp;&nbsp;
                  <a
                    href={
                      lang.langType === LANGTYPE_EN
                        ? "//www.qcew.com/home/english/index.asp"
                        : "//www.qcew.com/home/chinese/index.asp"
                    }
                    target="_blank"
                  >
                    <SearchIcon
                      sx={{
                        color: "#FFF",
                        ...textSize(22),
                        verticalAlign: "middle",
                      }}
                    ></SearchIcon>
                  </a>
                </span>
                <span
                  className="afterlogin"
                  style={{
                    display: isLogin ? "" : "none",
                    paddingLeft: "10px",
                  }}
                >
                  <div className="mobile_login_message">
                    <span className="hkjc_greeting_name">
                      {t("hi")}
                      {showDisplayName}
                    </span>
                    &nbsp;
                    <a
                      className="logout"
                      href="javascript:;"
                      onClick={(e) => redirectPage(e, "logout", lang.langType)}
                    >
                      {t("logout")}
                    </a>{" "}
                    /
                  </div>
                  <a
                    href="javascript:;"
                    onClick={(e) =>
                      redirectPage(e, "preference", lang.langType)
                    }
                  >
                    {t("preference")}
                  </a>
                  &nbsp;&nbsp;&nbsp;
                  <a
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "help", lang.langType)}
                    className="faq"
                  >
                    {t("faq")}
                  </a>
                  &nbsp;&nbsp;
                  <a
                    href={
                      lang.langType === LANGTYPE_EN
                        ? "//www.qcew.com/home/english/index.asp"
                        : "//www.qcew.com/home/chinese/index.asp"
                    }
                    target="_blank"
                  >
                    <SearchIcon
                      sx={{
                        color: "#FFF",
                        ...textSize(22),
                        verticalAlign: "middle",
                      }}
                    ></SearchIcon>
                  </a>
                </span>
              </span>
              <span className="mobile-top-lang">
                {Object.keys(LANGUAGE).map((key: string) => {
                  const code = str2LangCode(key);
                  if (lang.langCode === code) return;
                  return (
                    <a
                      key={`languageBtn_${key}`}
                      onClick={() => switchLanguage(code)}
                      className="lang"
                    >
                      {LANGUAGE[code].display}
                    </a>
                  );
                })}
              </span>
            </div>
            <div className="mm-panel">
              <div className="active" id="mm-1">
                <div className="mm-navbar">
                  <a className="mm-title" id="nav_title_hkjc">
                    {lang.langType === LANGTYPE_EN ? "HKJC" : "香港賽馬會"}
                  </a>
                </div>
                <ul className="mm-listview">
                  <li>
                    <a
                      id="home"
                      href={
                        lang.langType === LANGTYPE_EN
                          ? "//www.qcew.com/home/english/index.asp"
                          : "//www.qcew.com/home/chinese/index.asp"
                      }
                    >
                      {t("home")}
                    </a>
                  </li>
                  {mainMenu.map((item, index) => {
                    if (item?.label?.value) {
                      return (
                        <li key={`${item}_${index}`}>
                          <a
                            id={item?.name}
                            href={item?.link.value}
                            target={openNewWindow(item?.target?.value)}
                          >
                            {item?.label?.value}
                          </a>
                          {item.name === "02-Racing" ? (
                            <a
                              className="mm-next"
                              id="nav_next_mm_2"
                              href="javascript:;"
                              data-target="#mm-2"
                              onClick={(e) => changeMenu(e, "mm-1", "mm-2")}
                            ></a>
                          ) : (
                            <></>
                          )}
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
              <div className="inactive" id="mm-2">
                <div className="mm-navbar">
                  <a
                    className="mm-prev"
                    id="nav_prew_mm_1"
                    href="javascript:;"
                    data-target="#mm-1"
                    onClick={(e) => changeMenu(e, "mm-2", "mm-1")}
                  ></a>
                  <a className="mm-title" id="nav_title_02_Racing">
                    {
                      mainMenu.filter((item) => item.name === "02-Racing")[0]
                        ?.label.value
                    }
                  </a>
                </div>
                <ul className="mm-listview">
                  {subMena.map((sub, idx) => {
                    if (sub.label.value) {
                      return (
                        <li key={`${sub}_${idx}`}>
                          <a
                            id={sub.name}
                            href={sub.link.value}
                            target={openNewWindow(sub?.target?.value)}
                          >
                            {sub.label.value}
                          </a>
                          {!!(sub.children.length > 0) ? (
                            <a
                              className="mm-next"
                              id="nav_next_mm_3"
                              href="javascript:;"
                              data-target={"#mm-3" + idx}
                              onClick={(e) =>
                                changeMenu(e, "mm-2", "mm-3" + idx)
                              }
                            ></a>
                          ) : (
                            <></>
                          )}
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
              {subMena.map((sub, idx) => {
                if (sub.label.value) {
                  return !!sub.children ? (
                    <div
                      className="inactive"
                      id={"mm-3" + idx}
                      key={"mm-3" + idx}
                    >
                      <div className="mm-navbar">
                        <a
                          className="mm-prev"
                          id="nav_prew_mm_2"
                          href="javascript:;"
                          data-target="#mm-2"
                          onClick={(e) => changeMenu(e, "mm-3" + idx, "mm-2")}
                        ></a>
                        <a className="mm-title" id={"nav_title_mm_3" + idx}>
                          {sub.label.value}
                        </a>
                      </div>
                      <ul className="mm-listview">
                        {_.sortBy(sub.children, ["seqIndex"]).map(
                          (lvl: any, indx: number) => {
                            if (lvl.label.value) {
                              return (
                                <li key={`${lvl}_${indx}`}>
                                  <a
                                    id={lvl.name}
                                    href={lvl.link.value}
                                    target={openNewWindow(lvl?.target?.value)}
                                  >
                                    {lvl.label.value}
                                  </a>
                                  {!!(lvl.children?.filter((i:any) => i?.label?.value && i?.link?.value).length > 0) ? (
                                    <a
                                      className="mm-next"
                                      id="nav_next_mm_4"
                                      href="javascript:;"
                                      data-target={"#mm-4" + indx}
                                      onClick={(e) =>
                                        changeMenu(
                                          e,
                                          "mm-3" + idx,
                                          "mm-4" + indx
                                        )
                                      }
                                    ></a>
                                  ) : (
                                    <></>
                                  )}
                                </li>
                              );
                            }
                          }
                        )}
                      </ul>
                    </div>
                  ) : (
                    <></>
                  );
                }
              })}
              {subMena.map((sub, idx) => {
                return !!sub.children ? (
                  _.sortBy(sub.children, ["seqIndex"]).map(
                    (lvl: any, indx: number) => {
                      if (lvl.label.value) {
                        return !!lvl.children ? (
                          <div
                            className="inactive"
                            id={"mm-4" + indx}
                            key={"mm-4" + indx}
                            onClick={(e) =>
                              changeMenu(e, "mm-4" + indx, "mm-3" + idx)
                            }
                          >
                            <div className="mm-navbar">
                              <a
                                className="mm-prev"
                                id="nav_prew_mm_3"
                                href="javascript:;"
                                data-target={"#mm-3" + idx}
                              ></a>
                              <a
                                className="mm-title"
                                id={"nav_title_mm_4" + indx}
                              >
                                {lvl.label.value}
                              </a>
                            </div>
                            <ul className="mm-listview">
                              {_.sortBy(lvl.children, ["seqIndex"]).map(
                                (lvllast: any, ix: number) => {
                                  if (lvllast.label.value) {
                                    return (
                                      <li key={`${lvllast}_${ix}`}>
                                        <a
                                          id={lvllast.name}
                                          href={lvllast.link.value}
                                          target={openNewWindow(
                                            lvllast?.target?.value
                                          )}
                                        >
                                          {lvllast.label.value}
                                        </a>
                                      </li>
                                    );
                                  }
                                }
                              )}
                            </ul>
                          </div>
                        ) : (
                          <></>
                        );
                      }
                    }
                  )
                ) : (
                  <></>
                );
              })}
            </div>
          </nav>
        </Drawer>
      </Container>

      {/* <Script src={`${assetPrefix}/js/loadSSO.js`}   /> */}
      <Container
        disableGutters
        maxWidth={false}
        sx={{ display: { xs: "none", lg: "block" } }}
      >
        <SubMenu subData={mainMenu} />
      </Container>
    </>
  );
};

function displaySubMenu(e: any) {
  e.preventDefault();
  e.target.parentElement.parentElement.classList.add("dim");
  e.target.classList.add("active");
  e.target.parentElement.parentElement.classList.remove("first");
  adjustPosition(e.target, e.target.nextElementSibling);
}

function displaySubMenu2(e: any) {
  e.preventDefault();
  adjustPosition2(e.target, e.target.nextElementSibling);
}

function adjustPosition(curentTab: any, ele: any) {
  const rect = curentTab.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  if (viewportWidth - rect.right < 210) {
    ele.style.left = "auto";
    ele.style.right = "0";
  } else {
    ele.style.left = "0";
    ele.style.right = "auto";
  }
}
function hideSubMenu(e: any) {
  e.preventDefault();
  e.target.parentElement.parentElement.classList.remove("dim");
  const children = e.target.parentElement.children;
  for (const child of children) {
    child.classList.remove("active");
  }
  e.target.parentElement.parentElement.classList.remove("first");
}
function adjustPosition2(curentTab: any, ele: any) {
  const rect = curentTab.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  if (viewportWidth - rect.right < 210) {
    ele.style.left = "auto";
    ele.style.right = "100%";
  } else {
    ele.style.left = "100%";
    ele.style.right = "auto";
  }
}
function waTracker(name: string) {
  console.log("tracker name: ", name);
  // WATracker.trackClickEvent(name)
}

export default HeaderNav;
